import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import isUndefined from 'lodash/isUndefined';
import styles from './StockTickerTextWidget.css';
import ZCCstyles from './StockTickerTextWidget.ZCC.css';
import StockTickerLeftColumn from './StockTickerLeftColumn.js';
import StockTickerRightColumn from './StockTickerRightColumn.js';
let _styles = styles;

class StockTickerTextWidget extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      hasRendered:false,
      ulHeight:0,
      lineHeight:0
    };
    this.setDynamicULHeight = this.setDynamicULHeight.bind(this);

  }
  componentDidMount(){
    //if it hasnt rendered (highly likely)
    //we are going to call resize to appropriately size the widget
    //then we actually render
    if(!this.state.hasRendered){
      this.setDynamicULHeight(true);
    }

  }

  getWidgetFormat(){
    //based on my gridster li, props data-x and data-y
    //we size the widget properly
    const parentDimensions = this.props.getParentSize();
    let liFormat = styles.li;
    let labelFormat = _styles.stocksLabel;

    if(parentDimensions[0] <= 2){
      if(parentDimensions[1] === 2){
        //2x2
        liFormat = styles.li2x2;
        labelFormat = styles.label2x2;
      }
      else if(parentDimensions[1] < 2){
        liFormat = styles.li1y;
        labelFormat = styles.label1y;
      }
    }
    else if(parentDimensions[1] === 1){
      //wide but slim on the Y axis
      if(parentDimensions[0] >= 3){
        liFormat = styles.li1y;
        labelFormat = styles.label3x;
      }
      else{
        liFormat = styles.li1y;
        labelFormat = styles.label1y;
      }

    }
    if(parentDimensions[0] === 1){
      //very slim x axis, hide all uls
      liFormat = styles.li1x1;
    }
    return {li:liFormat,label:labelFormat};
  }
  getRangeLabel(){
    const {
      is52WeekRange
    } = this.props.data;
    let rangeLabel = 'Date Picker';
    if( is52WeekRange ){
      rangeLabel = '52 week';
    }
    return rangeLabel;
  }
  getAvgVolumeLabel(){
    const {
      is52WeekRange
    } = this.props.data;
    let avgVolumeLabel = 'Average Volume';
    if( is52WeekRange ){
      avgVolumeLabel = 'Last Sale Volume';
    }
    return avgVolumeLabel;
  }
  getAvgVolumeValue(){
    const {
      is52WeekRange,
      averageVolume,
      lastVolume
    } = this.props.data;
    let avgVolumeValue = averageVolume;
    if( is52WeekRange ){
      avgVolumeValue = lastVolume;
    }
    return avgVolumeValue;
  }
  getDiffStyle(){
    const {
      priceDiff
    } = this.props.data;
    let diffStyle = styles.none;
    if(parseFloat(priceDiff) < 0){
      diffStyle = styles.negative;
    }
    else if( parseFloat(priceDiff) > 0){
      diffStyle = styles.positive;
    }
    return diffStyle;
  }
  getPlusOrMinus(){
    const {
      priceDiff
    } = this.props.data;
    let plusOrMinus = ' ';
    if(parseFloat(priceDiff) < 0){
      plusOrMinus = ' ';
    }
    else if( parseFloat(priceDiff) > 0){
      plusOrMinus = '+';
    }
    return plusOrMinus;
  }
  getPlusOrMinusImage(){
    const {
      priceDiff
    } = this.props.data;
    let plusOrMinusImage = '';
    if(parseFloat(priceDiff) < 0){
      plusOrMinusImage = (
        <span className={[styles.downArrow,styles.arrow].join(' ')}>__</span>
      );

    }
    else if( parseFloat(priceDiff) > 0){
      plusOrMinusImage = (
        <span className={[styles.upArrow,styles.arrow].join(' ')}>__</span>
      );

    }
    return plusOrMinusImage;
  }
  setDynamicULHeight(forceRedraw){
    //do a responsive resize
    const titleElement = ReactDOM.findDOMNode(this).querySelector('#stockTitleElement');
    if( !isUndefined( titleElement ) ){

      const titleHeight = titleElement.getBoundingClientRect().height;
      const parentH = ReactDOM.findDOMNode(this).getBoundingClientRect().height;
      const height = Math.floor( parentH-titleHeight );
      const lineHeight = height/4 * 1.4; //a little padding

      this.setState({
        ulHeight:height,
        lineHeight
      });
      if(forceRedraw){
        this.setState({hasRendered:true});
        this.render(); //re-render now we know the heights involved
      }
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps){
    if (nextProps.data !== this.props.data || nextProps.isCommandCenter !== this.props.isCommandCenter) {
      this.setDynamicULHeight(false);
    }
  }

  renderLeftColumn(ulStyle,liStyle,liFormat,labelFormat){
    const {
      close,
      open,
      rangeToday,
    } = this.props.data;
    const leftMeta = {
      data:{
        open,
        close,
        rangeToday
      },
      styles:{
        styles,
        _styles,
        ulStyle,
        liStyle,
        liFormat,
        labelFormat
      },
      formatNumber:this.props.formatNumber
    };
    return (
      <StockTickerLeftColumn
        meta={leftMeta}
      />
      //cruft--
    );
  }
  renderRightColumn(ulStyle,liStyle,liFormat,labelFormat){
    const rangeLabel = this.getRangeLabel();
    const avgVolumeLabel = this.getAvgVolumeLabel();
    const avgVolumeValue = this.getAvgVolumeValue();
    const {
      rangeDates,
      volume
    } = this.props.data;
    const rightListMeta = {
      data: {
        rangeDates,
        volume
      },
      styles:{
        styles,
        _styles,
        ulStyle,
        liStyle,
        liFormat,
        labelFormat,
      },
      rangeLabel,
      avgVolumeLabel,
      avgVolumeValue,
      formatNumber:this.props.formatNumber
    };
    return (
      <StockTickerRightColumn
        meta={rightListMeta}
      />
      //and a comment to fix cruft.
    );

  }
  renderWidgetTitle(){
    const diffStyle = this.getDiffStyle();
    const plusOrMinus = this.getPlusOrMinus();
    const plusOrMinusImage = this.getPlusOrMinusImage();
    const {
      name,
      symbol,
      market,
      price,
      priceDiff,
      priceDiffPercent
    } = this.props.data;
    const titleMeta = (
      <div id="stockTitleElement" className={styles.stocksMeta}>
        <div className={_styles.stockTitle}>
          <span id="stockSymbolValue" className={_styles.stockSymbol}>{symbol}</span>
          <span id="stockTitleValue" className={styles.stockTitleName}>{name} - </span>
          <span id="marketTitleValue" className={styles.marketID}>{market}</span>
        </div>
        <div id="stockPriceMeta" className={_styles.stockPrice}>
          <span id="priceNowValue" className={_styles.price}>
            {this.props.formatNumber( price, 'decimal' )}
          </span>
          <span id="diffPriceValue" className={[_styles.change,diffStyle].join(' ')}>
            {plusOrMinus}
            {this.props.formatNumber( priceDiff, 'decimal' )}
            ({priceDiffPercent}%)
            {plusOrMinusImage}
          </span>
        </div>
      </div>
    );
    return titleMeta;
  }

  render(){
    _styles = this.props.isCommandCenter ? ZCCstyles : styles;
    const widgetFormat = this.getWidgetFormat();
    const liFormat = widgetFormat.li;
    const labelFormat = widgetFormat.label;

    let ulStyle = {};
    let liStyle = {};
    if(this.state.hasRendered){
      //if we have sized the widget viewport properly
      //we will now set the line height appropriately.
      ulStyle = {
        height: this.state.ulHeight+'px'
      };
      liStyle = {
        lineHeight: this.state.lineHeight+'px'
      };
    }

    const titleMetaEl = this.renderWidgetTitle();
    const ulLeftEl = this.renderLeftColumn(ulStyle,liStyle,liFormat,labelFormat);
    const ulRightEl = this.renderRightColumn(ulStyle,liStyle,liFormat,labelFormat);
    return (
      <div className={styles.stocksTable}>
        {titleMetaEl}
        {ulLeftEl}
        {ulRightEl}
      </div>
    );
  }

}

StockTickerTextWidget.propTypes = {
  getParentSize: PropTypes.func.isRequired,
  formatNumber: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  isCommandCenter: PropTypes.bool.isRequired
};

StockTickerTextWidget.defaultProps = {
  instanceID: PropTypes.string
};

export default StockTickerTextWidget;
